import type { TFunction } from "i18next";

interface IOption {
  value: string;
  label: string;
}

export const translateDropdownData = (
  data: Array<{ label?: string; name?: string }>,
  translationKeyBase: string,
  t: TFunction,
): IOption[] => {
  return data.map((item) => ({
    ...item,
    value: item.label ?? item.name ?? "",
    label: t(`${translationKeyBase}.${item.label ?? item.name ?? ""}`),
  }));
};
